export function safeLocaleCompare(a: string | undefined | number, b: string | undefined | number, sortingOrder: string): number {
  const strA = typeof a === "number" ? a.toString() : a;
  const strB = typeof b === "number" ? b.toString() : b;

  if (!strA && !strB) {
    return 0; // both are undefined, so they're equal
  } else if (!strA) {
    return 1; // a is undefined, so it's considered less than b
  } else if (!strB) {
    return -1; // b is undefined, so a is considered greater than b
  } else {
    return sortingOrder === "DESC" ? strB.localeCompare(strA) : strA.localeCompare(strB); // both are defined, so use localeCompare
  }
}

export function normalizeText(text: string | undefined): string {
  return text
    ? text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
    : "";
}
export function toCapitalCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function getStatusColor(status: string): string {
  switch (status) {
    case "PENDING":
      return "bg-gray-500";
    case "ASSIGNED":
      return "bg-blue-500";
    case "PROCESSING":
      return "bg-teal-600";
    case "QUEUED":
      return "bg-purple-500";
    case "PRINTING":
      return "bg-yellow-500";
    case "COMPLETED":
      return "bg-green-500";
    case "ABORTED":
      return "bg-red-500";
  }
  return "bg-gray-500";
}
export function getJobTypeColor(type: string): string {
  switch (type) {
    case "PRINT":
      return "bg-green-600";
    case "REPRINT":
      return "bg-blue-600";
    case "blankSpace":
      return "bg-slate-500";
  }
  return "bg-gray-500";
}
